import React from "react";
import { Serviceslider } from "./Serviceslider";

const Ourwork = () => {
  const serviceslider = [
{
  service: "./images/services/VMWork/MercedesMaybachLaunchEvent.jpg",
  title: "Mercedes Benz Maybach Launch Event at NMACC",
},
{
  service: "./images/services/VMWork/EurekaForbesOutdoorGSBBoard.jpg",
  title: "Eureka Forbes Outdoor GSB Board",
},
{
  service: "./images/services/VMWork/RelianceRetailKadeSpade.jpg",
  title: "Reliance Retail Kade Spade",
},
{
  service: "./images/services/VMWork/SuperdryProps.jpg",
  title: "Superdry Props",
},
{
  service: "./images/services/VMWork/SkodaBranding1.jpg",
  title: "Skoda Branding",
},
{
  service: "./images/services/VMWork/SkodaBranding2.jpg",
  title: "Skoda Branding",
},
{
  service: "./images/services/VMWork/MCCafeCup.jpg",
  title: "MC Cafe Cup",
},
{
  service: "./images/services/VMWork/TIMHORTONSGateArches.jpg",
  title: "TIM HORTONS Gate Arches",
},
{
  service: "./images/services/VMWork/TIMHORTONSBookMarks.jpg",
  title: "TIM HORTONS BookMarks",
},
{
  service: "./images/services/VMWork/TGLCoffeeInstoreBranding.jpg",
  title: "TGL Coffee Instore Branding",
},
{
  service: "./images/services/VMWork/PeterEnglandMainFacade.jpg",
  title: "Peter England Main Facade",
},
{
  service: "./images/services/VMWork/NEXONNEWLAUNCHCAMPAIGN.jpg",
  title: "TATA MOTORS- NEXON NEW LAUNCH CAMPAIGN",
},

{
  service: "./images/services/VMWork/TimHortonsOutdoorEventSetup.jpg",
  title: "Tim Hortons Outdoor Event Set up",
},
{
  service: "./images/services/VMWork/3DTataMotorsChargingStation.jpg",
  title: "3D design for Tata.ev Charging Station",
},
{
  service: "./images/services/VMWork/IndriyaOutdoorEventSetup.jpg",
  title: "Indriya Outdoor Event Set up",
},
{ 
  service: "./images/services/VMWork/IndriyaVMSetup.jpg",
  title: "Indriya VM Setup",
},
{
  service: "./images/services/VMWork/TanishqIndoorEventSetup.jpg",
  title: "Tanishq Indoor Event Set up",
},
{
  service: "./images/services/VMWork/IndriyaPOSElementLitTableTop.jpg",
  title: "Indriya POS Element Lit Table Top",
},
{
  service: "./images/services/VMWork/TanishqGateArches.jpg",
  title: "Tanishq Gate Arches",
},
  ];

  return (
    <div>
      <Serviceslider data={serviceslider} isautoPlay={true} />
    </div>
  );
};

export default Ourwork;